module.exports = __webpack_public_path__ + "img/Asset9.82546f5e.png";